'use client';

import { type ChipProps, Chip as MuiChip } from '@mui/material';
import { styled } from '@mui/material/styles';

import { campaignManagerTheme as themeStyles } from '@campaign-manager/theme';

export type Props = ChipProps;

const Chip = styled(MuiChip)(({ color, clickable }) => ({
  '&.MuiChip-root': {
    borderRadius: '16px',
    fontWeight: 500,
    transition: 'all 0.2s ease',
    // Default pill styling
    ...((!color || color === 'default') && {
      backgroundColor: '#f5f5f5',
      border: '1px solid #e0e0e0',
      '&:hover': {
        backgroundColor: '#eeeeee',
      },
    }),
    ...(color === 'info' && {
      color: themeStyles.color.infoTextColor,
    }),
    // Primary clickable styling
    ...(color === 'primary' &&
      clickable && {
        backgroundColor: '#e3f2fd',
        color: '#1976d2',
        border: '1px solid #90caf9',
        '&:hover': {
          backgroundColor: '#bbdefb',
          borderColor: '#64b5f6',
        },
        '&:focus': {
          backgroundColor: '#bbdefb',
        },
      }),
  },
}));

export default Chip;
